import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import Container from './Container'
import StoreHeaderSearch from './StoreHeaderSearch'
import MorrisonsLogo from '../assets/icons/logo.svg'

const propTypes = {
  sticky: PropTypes.bool,
  search: PropTypes.bool,
  children: PropTypes.node,
  categories: PropTypes.array,
}

const defaultProps = {
  sticky: false,
  search: false,
}

const SiteHeader = ({ sticky, search, storeType }) => {
  const isMorrisonsDaily = storeType === 'MorrisonsDaily'
  const storeTypeDefault = isMorrisonsDaily
    ? 'GasStation_Franchise_MorrisonsDaily'
    : storeType

  return (
    <div
      className={`top-0 relative shadow-md bg-white z-50 ${
        sticky ? 'lg:sticky' : ''
      }`}
    >
      <Container>
        <div className="flex items-center py-4 sm:-mx-3">
          <div className="sm:w-5/12 lg:w-4/12 sm:px-3">
            <Link to="/">
              <MorrisonsLogo className="block w-auto h-8 sm:h-12" />
            </Link>
          </div>
          <div className="w-7/12 ml-auto lg:w-6/12 sm:px-3 sm:block">
            {search && <StoreHeaderSearch storeType={storeTypeDefault} />}
          </div>
        </div>
      </Container>
    </div>
  )
}

SiteHeader.propTypes = propTypes
SiteHeader.defaultProps = defaultProps

export default SiteHeader
